import { render, staticRenderFns } from "./WorkerDetail.vue?vue&type=template&id=694d9258"
import script from "./WorkerDetail.vue?vue&type=script&lang=js"
export * from "./WorkerDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkerDetail.vue?vue&type=style&index=0&id=694d9258&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports